import * as Yup from 'yup';

const customerFiltersSchema = Yup.object({
  number: Yup.number()
    .nullable()
    .label('Asiakasnumero'),
  company: Yup.string()
    .nullable()
    .label('Yritys')
});

export default customerFiltersSchema;
export type CustomerFiltersSchema = ReturnType<
  typeof customerFiltersSchema.cast
>;
